import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "../css/shared.module.css";
import { FiCpu, FiAlertTriangle, FiArrowRight } from "react-icons/fi";

const BrainIncompleteModal = ({ isOpen, onClose, gptName, missingEntries = [] }) => {
  const navigate = useNavigate();

  const handleGoToBrain = () => {
    onClose();
    navigate("/brain");
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <div className={styles.modalTitle}>
            <FiAlertTriangle size={24} style={{ color: "#f59e0b", marginRight: "12px" }} />
            Brain Incompleto
          </div>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.brainIncompleteContent}>
            <div className={styles.brainIncompleteIcon}>
              <FiCpu size={64} style={{ color: "#3b82f6" }} />
            </div>
            
            <h3 className={styles.brainIncompleteTitle}>
              Necesitas completar tu Brain
            </h3>
            
            <p className={styles.brainIncompleteMessage}>
              El asistente <strong>"{gptName}"</strong> está configurado para usar tu Brain como contexto, 
              pero necesitas completar todas las entradas de tu Brain antes de poder usarlo.
            </p>

            <div className={styles.brainIncompleteSteps}>
              <h4>Para completar tu Brain:</h4>
              <ul>
                <li>Ve al módulo "Mi Cerebro"</li>
                <li>Completa las 7 entradas requeridas</li>
                <li>Guarda cada entrada con contenido personalizado</li>
                <li>Vuelve a este chat cuando esté completo</li>
              </ul>
              
              {missingEntries.length > 0 && (
                <div className={styles.missingEntriesSection}>
                  <h4>Entradas que necesitas completar:</h4>
                  <div className={styles.missingEntriesList}>
                    {missingEntries.map((entry, index) => (
                      <div key={index} className={styles.missingEntryItem}>
                        <FiAlertTriangle size={14} style={{ color: "#f59e0b", marginRight: "8px" }} />
                        <span>{entry}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className={styles.modalFooter}>
          <button
            type="button"
            onClick={onClose}
            className={`${styles.button} ${styles.secondary}`}
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={handleGoToBrain}
            className={`${styles.button} ${styles.primary}`}
          >
            <FiCpu size={16} />
            <span>Ir a Mi Cerebro</span>
            <FiArrowRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default BrainIncompleteModal;
